import { createGlobalStyle, css, FlattenSimpleInterpolation } from 'styled-components';
import { maxWidth } from 'config/constants';

export const SitePerformanceChartJsGlobalStyles = createGlobalStyle`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    .site-performance-chart__sort-segmented.ant-segmented {
      border: 2px solid ${kcc.colors.BORDER};
      padding: 2px;
      background-color: ${kcc.colors.WHITE};

      .ant-segmented-item-label {
        font-size: ${kcc.typography.FONT_SIZE.BASE}px;
        font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
        line-height: 20px;
        padding: 2px 16px;
        min-height: unset;
      }

      .ant-segmented-item-selected .ant-segmented-item-label {
        font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      }

      ${maxWidth.custom(480)} {
        .ant-segmented-group {
          flex-direction: column;
        }

        border-radius: 20px;
      }
    }

    .site-performance-chart__pagination {
      position: absolute;
      width: calc(100% - 4px);
      left: 2px;
      top: 124px;
      bottom: unset;
      height: 45px;
      background-image: linear-gradient(${kcc.colors.WHITE}E6, ${kcc.colors.WHITE}00);
      z-index: 1;

      &--disabled {
        display: none;
      }

      &:has(.site-performance-chart__pagination-button--next) {
        background-image: linear-gradient(${kcc.colors.WHITE}00, ${kcc.colors.WHITE}E6);
        top: unset;
        bottom: 26px;
      }

      .site-performance-chart__pagination-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
      }
    }
  `}
`;
